export default __webpack_public_path__ + "static/media/img (3).8ada6e64.jpg";